// FUNTION OF JSON WEB TOKEN => JWT
import jwt from 'jsonwebtoken'
require('dotenv').config()

const token = {
    signJwt: (user, expired) => {
        if(!expired){
            try {
                return jwt.sign({
                     email:user.email, password:user.password
                  }, process.env.REACT_APP_FA);
            } catch {
                return null
            }
        }else{
            try {

                return jwt.sign({
                    email:user.email, password:user.password
                  }, process.env.REACT_APP_FA, { expiresIn: expired.time})
            } catch {
                return null
            }
        }
    },

    verifyJwt: (token) => {
        try {
            return jwt.verify(token, process.env.REACT_APP_FA)
        } catch {
            return null
        }
    },

    encrypteJwt: (token) => {
            return new Buffer.from(token).toString(process.env.REACT_APP_KEY_ENCRYPT);
    },

    desencrypteJwt: (token) => {
            return new Buffer.from(token, process.env.REACT_APP_KEY_ENCRYPT).toString('ascii');
    }
}

export default token